// 缓存前缀
export const CACHE_PREFIX = 't-design-starter-next'
